import React from "react";
import "./footer.scss";
import logo from "../../asset/logo.webp";

const footer = () => {
  return (
    <div className="container-footer">
      <div className="container-atas">
        <div className="container-logo">
          <img className="gambar-logo" src={logo} alt="logo-pik" />
        </div>
        <div className="container-deskripsi">
          <div className="alamat">
            <h2>Marketing Gallery</h2>
            <h1>Pantai Indah Kapuk 2</h1>
            <p>Salembaran Jati, Kosambi, Tangerang Regency, Banten 15214</p>
          </div>
          <div className="contact">Contact us : +6285212538280 (Dennys)</div>
          <div className="privasi"></div>
        </div>
      </div>
      <div className="container-bawah">Pantai Indah Kapuk 2</div>
    </div>
  );
};

export default footer;
